/**
 * Lookbook (sections/oddit-section-lookbook.liquid)
 * - Reveal: blocks marked [data-lb-reveal] fade up the first time they enter the viewport.
 * - Videos: muted, looped, play only while on screen (and never under prefers-reduced-motion).
 * - Chapter menu: highlights the chapter currently in view.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function init(root) {
    if (root.__lbInit) return;
    root.__lbInit = true;

    // Reveal
    var reveals = root.querySelectorAll('[data-lb-reveal]');
    if (hasIO && !reduceMotion) {
      root.classList.add('is-ready');
      var revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            revealIO.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (el) { revealIO.observe(el); });
    }

    // Videos
    var videos = root.querySelectorAll('[data-lb-video]');
    if (!reduceMotion && hasIO) {
      var videoIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      videos.forEach(function (v) { videoIO.observe(v); });
    } else {
      videos.forEach(function (v) { v.preload = 'metadata'; });
    }

    // Chapter menu
    var links = root.querySelectorAll('[data-lb-nav-link]');
    if (links.length && hasIO) {
      var byId = {};
      links.forEach(function (a) { byId[a.getAttribute('data-lb-nav-link')] = a; });
      var current = null;
      var navIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var a = byId[e.target.id];
          if (!a || a === current) return;
          if (current) current.classList.remove('is-current');
          a.classList.add('is-current');
          current = a;
          // Keep the active chapter visible in the scrollable menu on phones.
          var list = a.parentNode && a.parentNode.parentNode;
          if (list && list.scrollWidth > list.clientWidth) {
            list.scrollTo({ left: a.offsetLeft - 16, behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      root.querySelectorAll('[data-lb-chapter]').forEach(function (ch) { navIO.observe(ch); });
    }
  }

  function initAll(scope) {
    (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-lookbook]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
